import { useState } from 'react';
import BasicModal from '__components/Modals/presets/BasicModal';
import Input from '__components/Kizen/Input';
import MultiSelect from '__components/Kizen/MultiSelect';
import { useTranslation } from 'react-i18next';
export const communicationTypeToLabel = (t: (key: string) => string) => ({
  receipts: t('Receipts'),
  overage_warnings: t('Overage Warnings'),
  overage_alerts: t('Overage Alerts'),
  failed_payments: t('Failed Payments'),
});

export const AddPaymentContactModal = (props: any) => {
  const { t } = useTranslation();
  const { onConfirm, existing } = props;
  const [emailAddress, setEmailAddress] = useState(existing?.email);
  const [communications, setCommunications] = useState(
    existing
      ? existing.communication_types.map((c: string) => ({
          value: c,
          label:
            communicationTypeToLabel(t)[
              c as keyof ReturnType<typeof communicationTypeToLabel>
            ] || c,
        }))
      : []
  );
  const [isMultiSelectOpen, setIsMultiSelectOpen] = useState(false);

  const handleMultiSelectFocus = () => {
    setIsMultiSelectOpen(true);
  };

  const handleMultiSelectApply = () => {
    setIsMultiSelectOpen(false);
  };

  return (
    <BasicModal
      {...props}
      size="small"
      heading={
        existing ? t('Edit Payment Contact') : t('Add New Payment Contact')
      }
      height={isMultiSelectOpen ? '500' : undefined}
      buttonText={t('Save')}
      disabled={!emailAddress || !communications.length}
      onConfirm={() =>
        onConfirm({
          email: emailAddress,
          communication_types: communications.map(
            (c: { value: string }) => c.value
          ),
        })
      }
    >
      <div className="pb-4">
        <Input
          data-qa="payment-contact-email"
          label={t('Email Address')}
          placeholder="user@example.com"
          value={emailAddress}
          onChange={setEmailAddress}
        />
      </div>
      <MultiSelect
        data-qa="payment-contact-communications"
        label={t('Communications Received')}
        placeholder={t('Choose Communications')}
        fullWidth
        values={communications}
        onChange={setCommunications}
        onFocus={handleMultiSelectFocus}
        onClickAway={handleMultiSelectApply}
        options={[
          {
            value: 'receipts',
            label: t('Receipts'),
          },
          {
            value: 'overage_warnings',
            label: t('Overage Warnings'),
          },
          {
            value: 'failed_payments',
            label: t('Failed Payments'),
          },
        ]}
      />
    </BasicModal>
  );
};
